import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { MetadataService } from 'src/app/api/metadata.service';
import { Currency } from 'src/app/models/currency';
import { ChatService } from 'src/app/services/chat.service';

interface CurrencyWithLink extends Currency {
  link?: string;
}
@Component({
  selector: 'supported-tokens',
  templateUrl: './supported-tokens.component.html',
  styleUrls: ['./supported-tokens.component.scss']
})
export class SupportedTokensComponent implements OnInit, OnDestroy {
  loading = true;
  error: string = null;

  searchValue: string;
  cryptos: CurrencyWithLink[];
  filteredCryptos: CurrencyWithLink[];
  fiatCurrency: string;
  isMobileWebView = false;

  queryParamsChangeSubscription: Subscription;

  constructor(
    private metadata: MetadataService,
    private currenciesService: CurrenciesService,
    private route: ActivatedRoute,
    private chatService: ChatService,
  ) { }

  async ngOnInit() {
    this._handleQueryParamsChange();
    await this.getDefaultFiatCurrency();
    this.getCryptoCurrencies();
  }

  ngOnDestroy() {
    this.queryParamsChangeSubscription?.unsubscribe();
  }

  private _handleQueryParamsChange() {
    this.queryParamsChangeSubscription = this.route.queryParamMap.subscribe(params => {
      this.isMobileWebView = params.get('mobile') === 'true';
      if (this.isMobileWebView) {
        this.chatService.destroy();
      }
    });
  }

  getDefaultFiatCurrency() {
    return this.metadata.userCurrency().pipe(
      tap(response => {
        this.fiatCurrency = response;
      }, () => {
        this.fiatCurrency = environment.currencies.defaultCurrency;
      })
    ).toPromise();
  }

  getCryptoCurrencies() {
    this.loading = true;
    this.currenciesService.getCrypto().subscribe(response => {
      this.cryptos = this.isMobileWebView ? response : this.updateCryptosWithLink(response);
      this.filteredCryptos = this.cryptos;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  updateCryptosWithLink(currencies: Currency[]): CurrencyWithLink[] {
    return currencies?.map(crypto => {
      const item: CurrencyWithLink = crypto;
      item.link = item?.acceptedPairs?.find(pair => pair.endsWith(this.fiatCurrency)) || item?.acceptedPairs?.[0];
      return item;
    });
  }

  filterData({ filteredItems, searchValue }) {
    this.filteredCryptos = filteredItems;
    this.searchValue = searchValue;
  }

  clearSearchValue() {
    this.searchValue = '';
  }
}
